// storageWithExpiry.ts
type StoredItem<T> = {
  value: T;
  expiry: number; // 만료 시각 (ms)
};

/**
 * localStorage에 value와 ttl(Time To Live)을 함께 저장
 * @param key   저장 키
 * @param value 저장할 값 (객체든 원시값이든 JSON.stringify 가능한 것)
 * @param ttl   유효기간(ms 단위). 예: 하루 = 24*60*60*1000
 */
export function setWithExpiry<T>(key: string, value: T, ttl: number) {
  const now = Date.now();
  const item: StoredItem<T> = {
    value,
    expiry: now + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * 만료 여부 검사 후 값 반환. 만료되었다면 localStorage에서 삭제하고 null 반환.
 * @param key 저장 키
 * @returns 저장된 값 또는 null
 */
export function getWithExpiry<T>(key: string): T | null {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item: StoredItem<T> = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    // 파싱 에러 등 문제 있을 땐 아예 삭제
    localStorage.removeItem(key);
    return null;
  }
}
